import React from 'react';
import Footer from '../components/Footer';
import Products from '../components/Products';

const ProductsPage = () => {
  return (
    <>
        <Products/>
        <Footer/>
    </>
  )
}

export default ProductsPage